var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contractPage"},[(_vm.showPageTitle)?_c('header',{staticClass:"bar bar-nav"},[_c('h2',[_vm._v(_vm._s(_vm.pageTitle))])]):_vm._e(),_c('div',{class:['content-page', {'hide-page-title': !_vm.showPageTitle}],domProps:{"innerHTML":_vm._s(_vm.pageData)}}),_c('div',{staticClass:"pageFooter"})])
}
var staticRenderFns = []

export { render, staticRenderFns }